import { render, staticRenderFns } from "./quick-order-voice.vue?vue&type=template&id=5f21fc7e&scoped=true&"
import script from "./quick-order-voice.vue?vue&type=script&lang=js&"
export * from "./quick-order-voice.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-voice.vue?vue&type=style&index=0&id=5f21fc7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21fc7e",
  null
  
)

export default component.exports